import commonPageService from 'pcCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import './reset.css';
import './style.css';

const init = () => {
    commonPageService({ renderAfter: syncRender, isMobile: 'auto' });
};

init();
